
import Home from '../pages/Home';
import LangDetect from '../pages/LangDetect';
import Sentiment from '../pages/Sentiment';
import Summarization from '../pages/Summarization';
import SentenceTokenizer from '../pages/SentenceTokenizer';
import NERTagger from '../pages/NERTagger';
import Keywords from '../pages/Keywords';
import Pricing from "../pages/Pricing";

import NotFound from '../pages/elements/404'
import Research from "../pages/Research";
import Sofie from "../pages/Sofie";
import Vertias from "../pages/Vertias";
import Atari from "../pages/Atari";

import Knowledge from "../pages/Knowledge";
import ChatGPTBlog from "../pages/Knowledge/ChatGPTBlog";
import SummarisationBlog from "../pages/Knowledge/SummarisationBlog";
import TokenizationBlog from "../pages/Knowledge/TokenizationBlog";
import SentimentBlog from "../pages/Knowledge/SentimentBlog";
import Keyword from "../pages/Knowledge/Keyword";
import LanguageDetection from "../pages/Knowledge/LanguageDetection";
import EntityRecognition from "../pages/Knowledge/EntityRecognition";

export const routes = [
	{
		path: '/language-detection',
		name: 'LangDetect',
		component: LangDetect
	},
	{
		path: '/sentiment',
		name: 'Sentiment',
		component: Sentiment
	},
	{
		path: '/text-summarization',
		name: 'Summarization',
		component: Summarization
	},
	{
		path: '/tokenizer',
		name: 'SentenceTokenizer',
		component: SentenceTokenizer
	},
	{
		path: '/entity-recognition',
		name: 'NERTagger',
		component: NERTagger
	},
	{
		path: '/keywords',
		name: 'Keywords',
		component: Keywords
	},
	{
		path: '/pricing',
		name: 'Pricing',
		component: Pricing
	},
	{
		path: '/research/sofie',
		name: 'Sofie',
		component: Sofie
	},
	{
		path: '/research/veritas',
		name: 'Vertias',
		component: Vertias
	},
	{
		path: '/research/atari',
		name: 'Atari',
		component: Atari
	},
	{
		path: '/research',
		name: 'Research',
		component: Research
	},
	{
		path: '/knowledge/chatgpt-alternatives',
		name: 'ChatGPTBlog',
		component: ChatGPTBlog
	},
	{
		path: '/knowledge/summarization',
		name: 'SummarisationBlog',
		component: SummarisationBlog
	},
	{
		path: '/knowledge/tokenization',
		name: 'TokenizationBlog',
		component: TokenizationBlog
	},
	{
		path: '/knowledge/sentiment-api',
		name: 'SentimentBlog',
		component: SentimentBlog
	},
	{
		path: '/knowledge/keyword',
		name: 'Keyword',
		component: Keyword
	},
	{
		path: '/knowledge/language-detection',
		name: 'LanguageDetection',
		component: LanguageDetection
	},
	{
		path: '/knowledge/entity-recognition',
		name: 'EntityRecognition',
		component: EntityRecognition
	},
	{
		path: '/knowledge',
		name: 'Knowledge',
		component: Knowledge
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},

	{
		path: '*',
		name: 'NotFound',
		component: NotFound
	}
];
